<template>
  <el-card style="height: 100%" shadow="always" v-loading="loading">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center justify-content-between">
        <h3 class="text-navy">Property Details</h3>
        <el-button class="btn-primary text-uppercase" @click="showModal()">New PIC</el-button>
      </div>
      <div class="col-12" v-loading="loading">
        <el-table :data="properties">
          <el-table-column label="PIC" prop="pic"></el-table-column>
          <el-table-column label="Name" prop="name"></el-table-column>
          <el-table-column label="Business" prop="owning_entity">
          </el-table-column>
          <el-table-column label="" prop="is_approved" width="100">
            <template slot-scope="scope">
              <i class="fa fa-check fa-lg text-green" v-if="scope.row.is_approved"></i>
              <div v-else class="text-casper">Pending Approval</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <business-property-modal :initial_business="business" :regions="regions" v-if="formModalShow"
      @close="formModalShow = false" @getData="getData" :initial_property="selectedProperty"></business-property-modal>
  </el-card>
</template>
<script>
import Property from "../../../modelsPortal/Property";
import Business from "../../../modelsPortal/Business";
export default {
  props: {
    initial_business: {
      type: Object
    },
    regions: {
      type: Array
    },
  },
  data() {
    return {
      business: this.initial_business,
      properties: [],
      loading: false,
      selectedProperty: null,
      formModalShow: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;

      let properties = new Property().for(new Business(this.business))
        .select("id", "name", "owning_entity", "pic", "is_approved")
        .params({ 'no_paginate': true })
        .orderBy("-id");

      properties
        .get()
        .then((res) => {
          this.loading = false;
          this.properties = res;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    showModal(property = null) {
      this.selectedProperty = property
      this.formModalShow = true
    }
  }
};
</script>